<template>
    <div id="container" type="vmortgagemrc" class="inline large page-mortgagemrc" >
         <div class="flex fixed fixed-max-sm middle space-between vertical-xs">
            <a class="logo" @click.prevent="openHome" title="Movoto" @keydown="enableKeyboardSupport" tabindex="0" role="link" aria-label="Movoto">
                <img style="height:24px;" :src="glb.cdnUrl + 'vimages/movoto-lower-logo.svg'" alt="Movoto"/>
            </a>
        </div>
        <mvtMortgageMrc :options="options"/>
    </div>
</template>

<script src="./page-mortgagemrc.js"></script>
<style lang="scss">
    @use "./page-mortgagemrc.scss" as *;
</style>